import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_claim_cycle_audit_trail_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  table_guid: fromDatatype.GuidDataFieldInterface;
  table_name: fromDatatype.VarcharDatatypeInterface;
  action: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  audit_trail_json: fromDatatype.JsonDatatypeInterface;
  action_date: fromDatatype.TimestampTzDatatypeInterface;
  action_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  action_by_subject_name: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_aat_claim_cycle_audit_trail_RowClass implements bl_aat_claim_cycle_audit_trail_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  table_guid: fromDatatype.GuidDataFieldInterface;
  table_name: fromDatatype.VarcharDatatypeInterface;
  action: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  audit_trail_json: fromDatatype.JsonDatatypeInterface;
  action_date: fromDatatype.TimestampTzDatatypeInterface;
  action_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  action_by_subject_name: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  
}
